import { parseISO, format, isValid } from 'date-fns';

export function getLancamentosColumns({
    titulo,
    optionsCentroCusto,
    optionsSituacao,
    tipo,
    isFolhaDePessoal,
    usaSubCentroCusto,
}) {
    return [
        {
            id: 'Lancamento',
            header: isFolhaDePessoal ? titulo + ' - Folha de Pessoal' : titulo,
            columns: [
                {
                    accessorKey: 'Pessoa.CPForCNPJ',
                    header: 'CPF ou CNPJ',
                    muiTableBodyCellProps: ({ row }) => ({
                        align: 'center',
                        onClick: () => {
                            console.info(row.original);
                        },
                    }),
                },
                {
                    accessorKey: 'Pessoa.nomePrincipal',
                    header: 'Parceiro',
                },
                {
                    accessorKey: 'valorOriginal',
                    header: 'Valor Original',
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    accessorFn: (row) => {
                        const valorOriginal = row.valorOriginal;

                        const valorFormatado =
                            !isNaN(parseFloat(valorOriginal)) && valorOriginal !== null && valorOriginal !== undefined
                                ? parseFloat(valorOriginal).toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  })
                                : 'R$ 0,00';

                        return 'R$ ' + valorFormatado;
                    },
                },
                {
                    accessorKey: 'parcelas',
                    header: 'Parcela',
                    muiTableBodyCellProps: {
                        align: 'center',
                    },
                },
                {
                    accessorKey: 'valor',
                    header: 'Valor Parcela',
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    accessorFn: (row) => {
                        const valor = row.valor;

                        const valorFormatado =
                            !isNaN(parseFloat(valor)) && valor !== null && valor !== undefined
                                ? parseFloat(valor).toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  })
                                : 'R$ 0,00';

                        return 'R$ ' + valorFormatado;
                    },
                },
                {
                    accessorKey: 'valorBaixado',
                    header: 'Valor Baixado',
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    accessorFn: (row) => {
                        const valorBaixado = row.valorBaixado;

                        const valorFormatado =
                            !isNaN(parseFloat(valorBaixado)) && valorBaixado !== null && valorBaixado !== undefined
                                ? parseFloat(valorBaixado).toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  })
                                : 'R$ 0,00';

                        return 'R$ ' + valorFormatado;
                    },
                },
                {
                    accessorKey: 'valorAberto',
                    header: 'Saldo',
                    muiTableBodyCellProps: {
                        align: 'right',
                    },
                    accessorFn: (row) => {
                        const valorAberto = row.valorAberto;

                        const valorFormatado =
                            !isNaN(parseFloat(valorAberto)) && valorAberto !== null && valorAberto !== undefined
                                ? parseFloat(valorAberto).toLocaleString('pt-BR', {
                                      style: 'decimal',
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                      minimumIntegerDigits: 1,
                                      useGrouping: true,
                                  })
                                : 'R$ 0,00';

                        return 'R$ ' + valorFormatado;
                    },
                },
                {
                    accessorFn: (row) => new Date(row),
                    accessorKey: 'dataVencimento',
                    header: 'Vencimento',
                    muiFilterTextFieldProps: {
                        sx: {
                            minWidth: '250px',
                        },
                    },
                    filterVariant: 'date',
                    sortingFn: 'date',
                    columnFilterModeOptions: [
                        'fuzzy',
                        'equals',
                        'between',
                        'betweenInclusive',
                        'greaterThanOrEqualTo',
                        'lessThanOrEqualTo',
                    ],
                    muiTableBodyCellProps: {
                        align: 'center',
                    },
                    muiTableHeadCellFilterTextFieldProps: {
                        type: 'date',
                        InputLabelProps: {
                            shrink: true,
                        },
                        sx: {
                            minWidth: '200px',
                        },
                    },
                    Cell: ({ row }) => {
                        return (
                            <span>
                                {row.original?.dataVencimento
                                    ? isValid(parseISO(row.original?.dataVencimento))
                                        ? format(parseISO(row.original?.dataVencimento), 'dd/MM/yyyy')
                                        : null
                                    : null}
                            </span>
                        );
                    },
                },
                {
                    accessorKey: 'Situacao.descricao',
                    header: 'Situação',
                    filterFn: 'equals',
                    columnFilterModeOptions: ['fuzzy', 'equals', 'notEquals'],
                    filterVariant: 'select',
                    filterSelectOptions: optionsSituacao,
                },
                {
                    accessorFn: (row) => new Date(row),
                    accessorKey: 'lancamentoBaixa.dataBaixa',
                    header: 'Baixa',
                    filterVariant: 'date',
                    sortingFn: 'date',
                    columnFilterModeOptions: [
                        'fuzzy',
                        'equals',
                        'between',
                        'betweenInclusive',
                        'greaterThanOrEqualTo',
                        'lessThanOrEqualTo',
                    ],
                    muiTableHeadCellFilterTextFieldProps: {
                        type: 'date',
                        InputLabelProps: {
                            shrink: true,
                        },
                        sx: {
                            minWidth: '200px',
                        },
                    },
                    muiTableBodyCellProps: {
                        align: 'center',
                    },
                    Cell: ({ row }) => {
                        return (
                            <span>
                                {row.original?.lancamentoBaixas?.[0]?.dataBaixa
                                    ? isValid(parseISO(row.original?.lancamentoBaixas?.[0]?.dataBaixa))
                                        ? format(parseISO(row.original?.lancamentoBaixas?.[0]?.dataBaixa), 'dd/MM/yyyy')
                                        : null
                                    : null}
                            </span>
                        );
                    },
                },
                {
                    accessorKey: 'centroCusto.descricao',
                    header: 'Centro Custo',
                    filterVariant: 'select',
                    filterSelectOptions: optionsCentroCusto,
                },
                // Condicional limpa usando o operador spread (...)
                ...(usaSubCentroCusto
                    ? [
                          {
                              accessorKey: 'SubCentroCusto.descricao', // Ajustei o accessorKey para o subcentro
                              header: 'Subcentro de Custo', // Ajustei o cabeçalho
                              filterVariant: 'select',
                              filterSelectOptions: optionsCentroCusto,
                          },
                      ]
                    : []),
                {
                    accessorKey: 'pagamentoForma.descricao',
                    header: 'Forma',
                },
                {
                    accessorKey: 'pagamentoPrazo.descricao',
                    header: 'Prazo',
                },
                {
                    accessorKey: 'Conta.descricao',
                    header: 'Conta',
                },
                {
                    accessorFn: (row) => new Date(row),
                    accessorKey: 'dataLancamento',
                    header: 'Lançamento',
                    filterVariant: 'date',
                    sortingFn: 'date',
                    columnFilterModeOptions: [
                        'fuzzy',
                        'equals',
                        'between',
                        'betweenInclusive',
                        'greaterThanOrEqualTo',
                        'lessThanOrEqualTo',
                    ],
                    muiTableBodyCellProps: {
                        align: 'center',
                    },
                    muiTableHeadCellFilterTextFieldProps: {
                        type: 'date',
                        InputLabelProps: {
                            shrink: true,
                        },
                        sx: {
                            minWidth: '200px',
                        },
                    },
                    Cell: ({ row }) => {
                        return (
                            <span>
                                {row.original?.dataLancamento
                                    ? isValid(parseISO(row.original?.dataLancamento))
                                        ? format(parseISO(row.original?.dataLancamento), 'dd/MM/yyyy')
                                        : null
                                    : null}
                            </span>
                        );
                    },
                },
                {
                    accessorKey: 'provisao',
                    header: 'Provisão',
                    type: 'boolean',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: [
                        { label: 'Todos', value: '' },
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' },
                    ],
                    filterVariant: 'select',
                    Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row.original.provisao ? 'Sim' : 'Não'}</div>,
                },
                {
                    accessorKey: 'custoFilial',
                    header: 'Custo Filial',
                    type: 'boolean',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: [
                        { label: 'Todos', value: '' },
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' },
                    ],
                    filterVariant: 'select',
                    Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row.original.custoFilial ? 'Sim' : 'Não'}</div>,
                },
                {
                    accessorKey: 'Empresa.nomeFantasia',
                    header: 'Empresa',
                },
                {
                    accessorKey: 'historico',
                    header: 'Histórico',
                },
                {
                    accessorKey: 'Pessoa.nomeFantasia',
                    header: 'Nome Fantasia',
                },
                {
                    accessorKey: 'codBarraPIX',
                    header: 'Código de Barras / PIX',
                    enableClickToCopy: true,
                },
                {
                    accessorKey: 'pessoaVinculada.nomeFantasia',
                    header: 'Parceiro Vinculado',
                },
                tipo === 'Receber' && {
                    accessorKey: 'negociado',
                    header: 'Negociado',
                    type: 'boolean',
                    columnFilterModeOptions: ['equals'],
                    filterSelectOptions: [
                        { label: 'Todos', value: '' },
                        { label: 'Sim', value: '1' },
                        { label: 'Não', value: '0' },
                    ],
                    filterVariant: 'select',
                    Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row.original.negociado ? 'Sim' : 'Não'}</div>,
                },
            ].filter(Boolean), // 🔥 ESSENCIAL,
        },
    ];
}
